import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useThemeStore = defineStore('theme', () => {
  const isDark = ref(localStorage.getItem('platform-theme') === 'dark')

  function toggle() {
    isDark.value = !isDark.value
    localStorage.setItem('platform-theme', isDark.value ? 'dark' : 'light')
  }

  return { isDark, toggle }
})
